import Api from "../../features/one-query/services/ApiServices";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  ConversationTypeRecord,
  conversationTypesActions,
} from "../one-query/conversationType";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { setFileError, setSnackBarAlert } from "../one-query/chatsSlice";
import { AxiosError } from "axios";
import { DescAndObjPersonaType } from "../../Helper";

/*
get ConversationTypes Endpoint
*/

// function to get all ConversationTypes
const getConversationTypes = async () => {
  try {
    const response = await Api.get("/ConversationType");
    return response.data;
  } catch (e) {}
};

// custom hook to get all ConversationTypes using useQuery
const useGetConversation = () => {
  const { data, isPending, error, refetch } = useQuery<
    ConversationTypeRecord[]
  >({
    queryKey: ["ConversationTypes"],
    queryFn: getConversationTypes,
    enabled: false,
  });

  return { data, isPending, error,refetch };
};

// hook to get all ConversationTypes query

const useGetConversationTypes = () => {
  const { data, isPending, error, refetch } = useGetConversation();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const getConversationTypesMutate = async () => {
    const { data } = await refetch();
    if (data) {
      dispatch(
        conversationTypesActions.getConversationTypes(
          data as ConversationTypeRecord[]
        )
      );
    }
  };
  return getConversationTypesMutate;
};

// ========================================================================================================

/*
createNewConversationType Endpoint
*/

// function to create a new ConversationType
const createNewConversationType = async (category: ConversationTypeRecord) => {
  try {
    const response = await Api.post(
      "/ConversationType",
      JSON.stringify(category)
    );

    return response.data;
  } catch (e) {
    throw e;
  }
};

// custom hook to create a new ConversationType using useMutation
const useCreateNewConversation = () => {
  //   <Error>  is the type of any error that might be thrown when the
  return useMutation({
    mutationKey: ["createNewConversationType"],
    mutationFn: createNewConversationType,
  });
};

// hook to create a new ConversationType query

const useCreateNewConversationType = () => {
  const queryClient = useQueryClient();
  const createConversation = useCreateNewConversation();
  const dispatch = useDispatch();
  const [createSuccess , setCreateSuccess] = useState(false);
  const createNewConversationMutate = (category: ConversationTypeRecord) => {
    createConversation.mutate(category, {
      onSuccess: (e: any) => {
        setCreateSuccess(true);
        dispatch(conversationTypesActions.newConversationType(e));
        queryClient.invalidateQueries({ queryKey: ["ConversationTypes"] });
        dispatch(setSnackBarAlert({show: true , message: "Persona added successfully" , alertType: "success" }))
      },
      onError: (error) => {
       const errorMessage : any = (error as AxiosError)?.response?.data;

        dispatch(
            setFileError({
              isError: true,
              errorMsg: errorMessage,
              reason: errorMessage,
            })
          );
      }
    });
  };
  const UpdateToggleCreation=(flag:boolean)=>{
    setCreateSuccess(false);
  }
  return {createNewConversationMutate , createSuccess, UpdateToggleCreation };
};

// ========================================================================================================
/*
updateConversationTypes Endpoint
*/

// function to update a ConversationType
const updateConversationType = async (category: ConversationTypeRecord) => {
  try {
    const response = await Api.patch(
      `/ConversationType/${category.id}`,
      JSON.stringify(category)
    );

    return response.data;
  } catch (e) {
    throw e;
  }
};

// custom hook to update a ConversationType using useMutation
const useUpdateConversation = () => {
  return useMutation({
    mutationKey: ["updateConversationType"],
    mutationFn: updateConversationType,
  });
};

// hook to update a ConversationType query

const useUpdateConversationType = () => {
  const updateConversation = useUpdateConversation();
  const dispatch = useDispatch();
  const [updateSuccess , setUpdateSuccess] = useState(false);

  const updateConversationTypeMutate = (category: ConversationTypeRecord) => {
    updateConversation.mutate(category, {
      onSuccess: () => {
        setUpdateSuccess(true)
        dispatch(conversationTypesActions.updateConversationType(category));
        dispatch(setSnackBarAlert({show: true , message: "Persona updated successfully" , alertType: "success" }))
      },
      onError: (error) => {
       const errorMessage : any = (error as AxiosError)?.response?.data;
        dispatch(
            setFileError({
              isError: true,
              errorMsg: errorMessage,
              reason: errorMessage,
            })
          );
      }
    });
  };
  const updateToggle=(flag:boolean)=>{
  setUpdateSuccess(flag);
  }
  return {updateConversationTypeMutate , updateSuccess, updateToggle };
};

// ========================================================================================================
/*
deleteConversationType Endpoint
*/

// function to delete a ConversationType
const deleteConversationType = async (id: string | null) => {
  try {
    const response = await Api.delete(`/ConversationType/${id}`);

    return response.data;
  } catch (e) {}
};

// custom hook to delete a ConversationType using useMutation
const useDeleteConversation = () => {
  return useMutation({
    mutationKey: ["deleteConversationType"],
    mutationFn: deleteConversationType,
  });
};

// hook to delete a ConversationType query

const useDeleteConversationType = () => {
  const queryClient = useQueryClient();
  const deleteConversation = useDeleteConversation();
  const dispatch = useDispatch();

  const deleteConversationTypeMutate = (id: string | null) => {
    deleteConversation.mutate(id, {
      onSuccess: () => {
        dispatch(conversationTypesActions.deleteConversationType(id));
        dispatch(setSnackBarAlert({show: true , message: "Persona deleted successfully" , alertType: "success" }))
      },
    });
  };
  return deleteConversationTypeMutate;
};
// function to Generte description and objective persona
const generateDescriptionAndObjectivePersona = async (PersonaData:DescAndObjPersonaType) => {
  try {
    const response = await Api.post(
      "/Chat/GetPersonaDescriptionAndObjective",
      JSON.stringify(PersonaData)
    );

    return response.data;
  } catch (e) {
    throw e;
  }
};

// custom hook using useMutation
const useGenerateDescriptionAndObjectivePersona = () => {
  return useMutation({
    mutationKey: ["generateDescriptionAndObjectivePersona"],
    mutationFn: generateDescriptionAndObjectivePersona,
  });
};
const useGenerativePersona = () => {
  const generateDescAndObjPersona = useGenerateDescriptionAndObjectivePersona();
  const generateDescAndObjPersonaMutate = (PersonaData:DescAndObjPersonaType) => {
    generateDescAndObjPersona.mutate(PersonaData,
      {
        onSuccess: (data) => {
        },
      }
    );
  };
  return generateDescAndObjPersonaMutate;
};
// Archieve Persona Endpoint
const ArchievePersona = async (id: string | null) => {
  try {
    const response = await Api.patch(`/ConversationType/Archive?Id=${id}`);

    return response.data;
  } catch (e) {}
};

// custom hook to archieve persona using useMutation
const useArchievePersona = () => {
  return useMutation({
    mutationKey: ["ArchievePersona"],
    mutationFn: ArchievePersona,
  });
};

// hook to delete a ConversationType query
const useArchievePersonaType = () => {
  const archievePersona = useArchievePersona();
  const dispatch = useDispatch();

  const archievePersonaMutate = (id: string | null) => {
    archievePersona.mutate(id, {
      onSuccess: (data) => {
        if (id)
          dispatch(
            conversationTypesActions.setPersonaArchieved({
              id: id,
              isArchieved: true,
            })
          );
          data&&(
        dispatch(
          setSnackBarAlert({
            show: true,
            message: data,
            alertType: "success",
            messageBody: "You can find archived persona in settings",
          }))
        );
      },
    });
  };
  return archievePersonaMutate;
};

// Unarchieve Persona Endpoint
const UnarchievePersona = async (id: string | null) => {
  try {
    const response = await Api.patch(`/ConversationType/UnArchive?Id=${id}`);

    return response.data;
  } catch (e) {}
};

// custom hook to archieve persona using useMutation
const useUnarchievePersona = () => {
  return useMutation({
    mutationKey: ["UnarchievePersona"],
    mutationFn: UnarchievePersona,
  });
};

// hook to delete a ConversationType query
const useUnarchievePersonaType = () => {
  const unarchievePersona = useUnarchievePersona();
  const dispatch = useDispatch();
  const unarchievePersonaMutate = (id: string | null) => {
    unarchievePersona.mutate(id, {
        onSuccess: (data) => {
        if (id)
          dispatch(
            conversationTypesActions.setPersonaArchieved({
              id: id,
              isArchieved: false,
            })
          );
        dispatch(
          setSnackBarAlert({
            show: true,
            message: data,
            alertType: "success",
          })
        );
      },
    });
  };
  return unarchievePersonaMutate;
};
// ========================================================================================================

export {
  useGetConversationTypes,
  useCreateNewConversationType,
  useUpdateConversationType,
  useDeleteConversationType,
  useGenerativePersona,
  useArchievePersonaType,
  useUnarchievePersonaType,
};
